import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const getCrops = async (currentPage, itemsPerPage, filters = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/crops/all`, {
            params: {
                page: currentPage,
                limit: itemsPerPage,
                ...filters,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener los cultivos: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getCrop = async (cropId) => {
    try {
        const response = await axios.get(`${apiUrl}/crops/${cropId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al obtener el cultivo id ${cropId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const addCrop = async (body) => {
    try {
        const response = await axios.post(`${apiUrl}/crops/create`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error al crear el cultivo: ", error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const editCrop = async (cropId, body) => {
    try {
        const response = await axios.put(`${apiUrl}/crops/${cropId}`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al actualizar el cultivo id ${cropId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const deleteCrop = async (cropId) => {
    try {
        const response = await axios.delete(`${apiUrl}/crops/${cropId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error(`Error al eliminar el cultivo id ${cropId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}